import './Toaster.scss';
import React from 'react';
import PropTypes from 'prop-types';

class ConfirmationToaster extends React.Component {
  static propTypes = {
    icon: PropTypes.string,
    confirmText: PropTypes.string,
    dismissText: PropTypes.string,
    onConfirm: PropTypes.func.isRequired,
    onDismiss: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
  };

  static contextTypes = {
    getString: PropTypes.func.isRequired,
  };

  ICONS = {
    check: 'glyphicon-ok',
    cross: 'glyphicon-remove',
  };

  renderActionBar() {
    const { getString } = this.context;
    return (
      <div className="toaster-action">
        <a className="btn btn-link" onClick={this.props.onDismiss}>
          <span>{this.props.dismissText || getString('AA_Cancel')}</span>
        </a>
        <a className="btn btn-link" onClick={this.props.onConfirm}>
          <span>{this.props.confirmText || getString('AA_OK')}</span>
        </a>
      </div>
    );
  }

  render() {
    return (
      <div className="toaster-wrapper">
        <div className="toaster-background" onClick={this.props.onDismiss} />
        <div className="toaster">
          <div className="toaster-content">
            <div className="toaster-icon">
              <span className={`glyphicon ${this.ICONS[this.props.icon] || ''}`} aria-hidden="true" />
            </div>
            <span className="toaster-text" aria-live="polite" dangerouslySetInnerHTML={{ __html: this.props.text }} />
          </div>
          {this.renderActionBar()}
        </div>
      </div>
    );
  }
}

ConfirmationToaster.defaultProps = {
  icon: 'cross',
};

export default ConfirmationToaster;
